import BaseResource from './BaseResource';

export default class MarketplaceSupplierResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  get() {
    return super
      .get()
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(data) {
    return super
      .patch(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }
}
